import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import {RestClient} from '../Api/DcoApi/Client/RestClient';


interface StartResult{
  started: boolean;
}

export interface hub {
   stop(): Promise<void>
}

@Injectable({ providedIn: 'root' })
export class NotificationService {


  ApiClient:RestClient = new RestClient();



  constructor() {

  }

  public async RunFunction<T>(functioncall: string, postItem: T, Information?: (result: any) => void ): Promise<hub | null>{
    var hub = new signalR.HubConnectionBuilder()
      .withUrl('/NotificationHub')
      .withAutomaticReconnect()
      .build();

    hub.on('Information', p => {
      if(Information)
        Information(p)
    });

    hub.onclose(c => {
      if(Information)
        Information(c)
      else
        throw c;
      console.log(c)

    });

    await hub.start();

    var result = await this.ApiClient.Post<StartResult,T>(`${functioncall}${hub.connectionId}` , postItem)

    if(result.started)
      return hub as hub;

    await hub.stop();

    return null;
  }

  public async RunDownload(functioncall: string, fileName: string, Information?: (result: any) => void ){
    var hub = new signalR.HubConnectionBuilder()
      .withUrl('/NotificationHub')
      .withAutomaticReconnect()
      .build();

    hub.on('Information', p => {
      if(Information)
        Information(p)
    });

    hub.onclose(c => {
      if(Information)
        Information(c)
      else
        throw c;
      console.log(c)

    });

    await hub.start();

    try {


      var response = await this.ApiClient.GetFile(`${functioncall}${hub.connectionId}`)

      const blob = response.body;
      if (!blob) {
        throw new Error('Response body is empty.');
      }

      // 2. Extract the filename from the Content-Disposition header if available
      const disposition = response.headers.get('content-disposition');
      if (disposition && disposition.includes('filename=')) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          fileName = matches[1].replace(/['"]/g, '');
        }
      }

      // 4. Create a local URL pointing to that blob
      const blobUrl = window.URL.createObjectURL(blob);

      // 5. Create an invisible <a> tag dynamically
      const anchor = document.createElement('a');
      anchor.href = blobUrl;
      anchor.download = fileName;

      // 6. Append to DOM, trigger click, and clean up immediately
      document.body.appendChild(anchor);
      anchor.click();

      // Cleanup
      document.body.removeChild(anchor);
      window.URL.revokeObjectURL(blobUrl);
    }catch (e)
    {
      console.log(e);
    }
    await hub.stop();

  }

}
